import createIconComponent from '../bc9b7e13473c3bebabd83c78ec2a0778f96c4118bed2ed7cc3a817be7d068301.cfe-internal.js';

/* THIS FILE IS AUTO-GENERATED */
var CaretDownIcon = /*#__PURE__*/createIconComponent('CaretDown', '<path d="M16.643 10.5001H7.35729C7.14852 10.5001 7.05231 10.7591 7.21066 10.8949L11.8535 14.8744C11.9378 14.9467 12.0624 14.9467 12.1468 14.8744L16.7896 10.8949C16.948 10.7591 16.8517 10.5001 16.643 10.5001Z"/>');

export { CaretDownIcon as default };
